import { SET_LOADING_STATUS } from './actionType';

export const setLoadingStatus = (data) => {
  return { type: SET_LOADING_STATUS, payload: data };
};
